import {
  Box,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import "./RequestQuote.css";
import { makeStyles } from "@material-ui/core/styles";
import HomeIcon from "@material-ui/icons/Home";
import AllInclusiveIcon from "@material-ui/icons/AllInclusive";
import { ToastContainer, toast } from "react-toastify";
import Header from "../../Shard/Navbar/Header";
import { useNavigate } from "react-router-dom";
import LoadingAndUnLoading from "./LoadingAndUnLoading";
import ProjectDetails from "./ProjectDetails";
import axios from "axios";
import Footer from "../../Shard/Footer/Footer";
import { AuthContext } from "../../../context/AuthContext";
import LoadingMobile from "./LoadingMobile";
import PrMobile from "./PrMobile";

const useStyles = makeStyles({
  quoteHeading: {
    display: "flex",
    justifyContent: "space-between",
    background: "#DEECFC",
    padding: "10px 20px",
    borderRadius: "10px",
    margin: "10px 0",
  },
  quoteContent: {
    padding: "10px 0px",
    borderRadius: "5px",
  },
  title: {
    paddingBottom: "0px",
  },
  requestQuoteTitle: {
    display: "flex",
    alignItems: "center",
    columnGap: "5px",
  },
  formControl: {
    minWidth: 300,
  },
  selectEmpty: {},
  quoteContainer: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
  },
  requestQuote1Submit: {
    width: "160px",
    height: "45px",
    marginInlineEnd: "10px",
    background: "#BE1E2D",
    color: "#fff",
    marginTop: "20px",
    fontWeight: "600",
  },
});

const RequestQuote = ({
  isShaw,
  setIsShaw,
  setModalOpen,
  setLoginModalOpen,
  productData,
  vehicleData,
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const userId = user?.detail?._id;
  const [quoteIntValue, setQuoteIntValue] = React.useState({
    productType: undefined,
    transportationType: undefined,
    packaging: undefined,
    loadDate: undefined,
    vehicleType: undefined,
    deliveryDate: undefined,
  });
  const [productCount, setProductCount] = useState([{ name: "1" }]);
  const [loadingUnLoadingCount, setLoadingUnLoadingCount] = useState([
    { name: "1" },
  ]);
  const [productDetailsValue, setProductDetailsValue] = React.useState([]);
  const [loadingUnDetailsValue, setLoadingUnDetailsValue] = React.useState([]);

  const [loadValue, setLoadValue] = React.useState({
    flexibleReadyDate: false,
    flexibleReadyDate1: false,
    flexibleReadyDate2: false,
    flexibleReadyDate3: false,
    flexibleEndDeliveryDate1: false,
    flexibleEndDeliveryDate2: false,
    flexibleEndDeliveryDate3: false,
    flexibleEndDeliveryDate: false,
  });

  const [driverReq, setDriverReq] = React.useState({
    training: false,
    PPE: false,
    entryPermits: false,
  });

  const [associatedServiceValue, setAssociatedServiceValue] = React.useState({
    insuracnce: false,
    certification: false,
    inspectionServices: false,
    customClearance: false,
    associatedEntryPermits: false,
  });

  const [requiredEquipmentValue, setRequiredEquipmentValue] = React.useState({
    liftgate: false,
    palletJack: false,
    loadStraps: false,
    loadBars: false,
    TIRCable: false,
    sideLoading: false,
    pump: false,
    flowMeter: false,
    scullySystem: false,
    lashBelt: false,
    tarpaulin: false,
  });

  const [remarks, setRemarks] = React.useState({
    remarks: undefined,
  });

  const handleChangeQuoteIntValue = (event) => {
    const name = event.target.name;

    setQuoteIntValue({
      ...quoteIntValue,
      [name]: event.target.value,
    });
  };

  const handleChangeLoadValue = (event) => {
    const name = event.target.name;
    setLoadValue({
      ...loadValue,
      [name]: event.target.value,
      [name]: event.target.checked,
    });
  };

  const handleChangedriverReq = (event) => {
    const name = event.target.name;
    setDriverReq({
      ...driverReq,
      [name]: event.target.checked,
    });
  };

  const handleChangeAssociatedService = (event) => {
    setAssociatedServiceValue({
      ...associatedServiceValue,
      [event.target.name]: event.target.checked,
    });
  };

  const handleChangeRequiredEquipment = (event) => {
    setRequiredEquipmentValue({
      ...requiredEquipmentValue,
      [event.target.name]: event.target.checked,
    });
  };

  const handleChangeRemarks = (event) => {
    const name = event.target.name;
    setRemarks({
      ...remarks,
      [name]: event.target.value,
    });
  };

  const handleChangePdValue = (event, i) => {
    const name = event.target.name;
    const value = productDetailsValue;
    const isExist = value.find((item) => {
      return item.serial === i;
    });
    let currentValue = {};
    if (isExist) {
      const index = value.indexOf(isExist);
      currentValue = { ...isExist };
      currentValue[name] = event.target.value;
      if (index !== -1) {
        value[index] = currentValue;
      }
    } else {
      currentValue.serial = i;
      currentValue[name] = event.target.value;
      value.push(currentValue);
    }
    setProductDetailsValue(value);
  };

  const handleChangePdLoadingUnloading = (event, i) => {
    const name = event.target.name;
    const value = loadingUnDetailsValue;
    const isExist = value.find((item) => {
      return item.serial === i;
    });
    let currentValue = {};
    if (isExist) {
      const index = value.indexOf(isExist);
      currentValue = { ...isExist };
      currentValue[name] = event.target.value;
      if (index !== -1) {
        value[index] = currentValue;
      }
    } else {
      currentValue.serial = i;
      currentValue[name] = event.target.value;
      value.push(currentValue);
    }
    setLoadingUnDetailsValue(value);
  };

  const handleIncrementLoadingUnloading = () => {
    setLoadingUnLoadingCount([...loadingUnLoadingCount, { name: "1" }]);
  };

  const hanldeIncrementDetails = () => {
    setProductCount([...productCount, { name: "1" }]);
  };

  const notify = () => {
    toast.success("Success", {
      position: toast.POSITION.TOP_CENTER,
    });
  };
  const error = (data) => {
    toast.error(data, {
      position: toast.POSITION.TOP_CENTER,
    });
  };
  let saveDrfat = true;
  let open = true;
  const handleSaveDrfat = async (e) => {
    e.preventDefault();
    let data = {
      quoteIntValue,
      productDetailsValue,
      loadingUnDetailsValue,
      loadValue: {
        ...loadValue,
        expectedDeliveryDate: quoteIntValue.deliveryDate,
        loadReady: quoteIntValue.loadDate,
      },
      driverReq,
      associatedServiceValue,
      requiredEquipmentValue,
      remarks,
    };
    try {
      const res = await axios.post(
        "https://abc-backend.onrender.com/api/quotes/quote",
        (data = { data, saveDrfat, open, userId })
      );
      if (res.data) {
        notify();
        navigate("/dashboard/my-req");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    saveDrfat = false;
    let data = {
      quoteIntValue,
      productDetailsValue,
      loadingUnDetailsValue,
      loadValue,
      driverReq,
      associatedServiceValue,
      requiredEquipmentValue,
      remarks,
    };

    if (
      Object.values(data.driverReq).find((item) => item === true) &&
      Object.values(data.requiredEquipmentValue).find(
        (item) => item === true
      ) &&
      Object.values(data.associatedServiceValue).find((item) => item === true)
    ) {
      try {
        const res = await axios.post(
          "https://abc-backend.onrender.com/api/quotes/quote",
          (data = { data, saveDrfat, open, userId })
        );
        if (res.data) {
          alert("data Submited successfully");
          notify();
          navigate("/");
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      error(
        "You Can't Empty Associated Service and Required Equipment and Driver Requirements"
      );
    }
  };
  const handleCountDelete = (item, i) => {
    const filterCount = productCount.filter((_, index) => index !== i);
    setProductCount(filterCount);
  };
  const handleLoadingUnloadDelete = (i) => {
    const filterCount = loadingUnLoadingCount.filter((_, index) => index !== i);
    setLoadingUnLoadingCount(filterCount);
  };
  return (
    <div className="Request-a-Quote">
      <Header
        isShaw={isShaw}
        setIsShaw={setIsShaw}
        setLoginModalOpen={setLoginModalOpen}
        setModalOpen={setModalOpen}
      />

      <Container>
        <form
          className="requsetQuote"
          style={{ paddingTop: "95px" }}
          onSubmit={handleSubmit}
        >
          <Box className={classes.quoteHeading}>
            <Box>
              <Typography variant="h6">Request a Quote</Typography>
            </Box>
            <Box>
              <Typography variant="h6">Load Calculater</Typography>
            </Box>
          </Box>
          <Container>
            <div style={{ padding: "30px 0" }}>
              <Box>
                <Grid container spacing={3}>
                  <Grid item xs={12} lg={4} md={4}>
                    <Box className="quote_inputIcon">
                      <Box>
                        <span>Product Type</span> <br />
                        <Select
                          native
                          name="productType"
                          onChange={handleChangeQuoteIntValue}
                        >
                          <option aria-label="None" value="" disabled selected>
                            please select
                          </option>
                          {productData?.map((pdData) => (
                            <option value={pdData.productType} key={pdData._id}>
                              {pdData.productType}
                            </option>
                          ))}
                        </Select>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} lg={4} md={4}>
                    <Box className="quote_inputIcon">
                      <Box>
                        <span>Transportation Type</span> <br />
                        <Select
                          native
                          name="transportationType"
                          onChange={handleChangeQuoteIntValue}
                        >
                          <option aria-label="None" value="" disabled selected>
                            please select{" "}
                          </option>
                          <option value={"FTL"}>FTL</option>
                          <option value={"LTL"}>LTL</option>
                        </Select>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} lg={4} md={4}>
                    <Box className="quote_inputIcon">
                      <Box>
                        <span className="req_input_label">Packaging</span>{" "}
                        <TextField
                          id="outlined-basic"
                          variant="outlined"
                          name="packaging"
                          required
                          onChange={handleChangeQuoteIntValue}
                          className="req_input_heading"
                          type="text"
                        />
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              <Box>
                <Grid container spacing={3}>
                  <Grid item xs={12} lg={4} md={4}>
                    <Box className="quote_inputIcon">
                      <Box>
                        <span className="req_input_label">Ready to Load</span>
                        <TextField
                          id="outlined-basic"
                          variant="outlined"
                          name="loadDate"
                          required
                          onChange={handleChangeQuoteIntValue}
                          className="req_input_heading"
                          defaultValue={"30/09/2022"}
                          type="date"
                        />
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} lg={4} md={4}>
                    <Box className="quote_inputIcon">
                      <Box>
                        <span>Truck Type</span> <br />
                        <Select
                          native
                          required
                          name="vehicleType"
                          onChange={handleChangeQuoteIntValue}
                        >
                          <option aria-label="None" value="" disabled selected>
                            please select
                          </option>
                          {vehicleData?.map((vcData) => (
                            <option value={vcData.vehicleType} key={vcData._id}>
                              {vcData.vehicleType}
                            </option>
                          ))}
                        </Select>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} lg={4} md={4}>
                    <Box className="quote_inputIcon bigLabel">
                      <Box>
                        <span className="req_input_label">
                          Estimated Delivery Date
                        </span>
                        <TextField
                          id="outlined-basic"
                          variant="outlined"
                          name="deliveryDate"
                          required
                          onChange={handleChangeQuoteIntValue}
                          className="req_input_heading"
                          defaultValue="03/09/2022"
                          type="date"
                        />
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </div>
          </Container>
          {/*Loding and Unloading Details  */}
          <LoadingAndUnLoading
            handleChangePdLoadingUnloading={handleChangePdLoadingUnloading}
            handleLoadingUnloadDelete={handleLoadingUnloadDelete}
            handleIncrementLoadingUnloading={handleIncrementLoadingUnloading}
            loadingUnLoadingCount={loadingUnLoadingCount}
          />
          {/* Ready to Load */}
          <Box>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={6} md={12}>
                <Container>
                  <Box className="">
                    <Box>
                      <Box className={classes.title}>
                        <Typography
                          variant="h6"
                          className={classes.requestQuoteTitle}
                        >
                          <span>Ready to Load</span>
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      style={{
                        display: "flex",
                        columnGap: "20px",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <Box className="loadinUnloadingInput">
                        <TextField
                          id="outlined-basic"
                          variant="outlined"
                          name="loadReady"
                          disabled
                          value={quoteIntValue.loadDate}
                          onChange={handleChangeLoadValue}
                        />
                      </Box>
                      <Box>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={loadValue.flexibleReadyDate}
                              onChange={handleChangeLoadValue}
                              name="flexibleReadyDate"
                              color="primary"
                            />
                          }
                          label="Flexible dates"
                        />
                      </Box>
                    </Box>
                    {loadValue.flexibleReadyDate && (
                      <Box style={{ display: "flex", gap: "2rem" }}>
                        <Box>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={loadValue.flexibleReadyDate1}
                                onChange={handleChangeLoadValue}
                                name="flexibleReadyDate1"
                                color="primary"
                              />
                            }
                            label="1Day"
                          />
                        </Box>
                        <Box>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={loadValue.flexibleReadyDate2}
                                onChange={handleChangeLoadValue}
                                name="flexibleReadyDate2"
                                color="primary"
                              />
                            }
                            label="2Day"
                          />
                        </Box>
                        <Box>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={loadValue.flexibleReadyDate3}
                                onChange={handleChangeLoadValue}
                                name="flexibleReadyDate3"
                                color="primary"
                              />
                            }
                            label="3Day"
                          />
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Container>
              </Grid>
              <Grid item xs={12} lg={6} md={12}>
                <Container>
                  <Box className="">
                    <Box>
                      <Box className={classes.title}>
                        <Typography
                          variant="h6"
                          className={classes.requestQuoteTitle}
                        >
                          <span>Expected Delivery Date</span>
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      style={{
                        display: "flex",
                        columnGap: "20px",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <Box className="loadinUnloadingInput">
                        <TextField
                          id="outlined-basic"
                          variant="outlined"
                          disabled
                          value={
                            quoteIntValue.deliveryDate
                              ? quoteIntValue.deliveryDate
                              : ""
                          }
                          name="expectedDeliveryDate"
                          onChange={handleChangeLoadValue}
                        />
                      </Box>
                      <Box>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={loadValue.flexibleEndDeliveryDate}
                              onChange={handleChangeLoadValue}
                              name="flexibleEndDeliveryDate"
                              color="primary"
                            />
                          }
                          label="Flexible dates"
                        />
                      </Box>
                    </Box>
                    {loadValue.flexibleEndDeliveryDate && (
                      <Box style={{ display: "flex", gap: "2rem" }}>
                        <Box>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={loadValue.flexibleEndDeliveryDate1}
                                onChange={handleChangeLoadValue}
                                name="flexibleEndDeliveryDate1"
                                color="primary"
                              />
                            }
                            label="1Day"
                          />
                        </Box>
                        <Box>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={loadValue.flexibleEndDeliveryDate2}
                                onChange={handleChangeLoadValue}
                                name="flexibleEndDeliveryDate2"
                                color="primary"
                              />
                            }
                            label="2Day"
                          />
                        </Box>
                        <Box>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={loadValue.flexibleEndDeliveryDate3}
                                onChange={handleChangeLoadValue}
                                name="flexibleEndDeliveryDate3"
                                color="primary"
                              />
                            }
                            label="3Day"
                          />
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Container>
              </Grid>
            </Grid>
          </Box>

          {/* Driver Requirements */}
          <Box>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={6} md={12}>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: "10px",
                    paddingBottom: "15px",
                  }}
                >
                  <Typography variant="span">
                    <HomeIcon />
                  </Typography>
                  <Typography variant="h6">Driver Requirements </Typography>
                </Box>
                <Container>
                  <Box className="">
                    <Box
                      style={{
                        display: "flex",
                        columnGap: "20px",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <Box>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={driverReq.training}
                              onChange={handleChangedriverReq}
                              name="training"
                              color="primary"
                            />
                          }
                          label="Training"
                        />
                      </Box>
                      <Box>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={driverReq.PPE}
                              onChange={handleChangedriverReq}
                              name="PPE"
                              color="primary"
                            />
                          }
                          label="PPE"
                        />
                      </Box>
                      <Box>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={driverReq.entryPermits}
                              onChange={handleChangedriverReq}
                              name="entryPermits"
                              color="primary"
                            />
                          }
                          label="Entry Permits"
                        />
                      </Box>
                    </Box>
                  </Box>
                </Container>
              </Grid>
              <Grid item xs={12} lg={6} md={12}></Grid>
            </Grid>
          </Box>
          {/* Product Details */}
          <ProjectDetails
            handleChangePdValue={handleChangePdValue}
            hanldeIncrementDetails={hanldeIncrementDetails}
            handleCountDelete={handleCountDelete}
            productCount={productCount}
          />
          {/* Associated Service  */}
          <Box className={classes.quoteContent}>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={12} md={12}>
                <Box className="">
                  <Box>
                    <Box className={classes.title}>
                      <Typography
                        variant="h6"
                        className={classes.requestQuoteTitle}
                      >
                        <span className="ServiceIcon">
                          <AllInclusiveIcon />
                        </span>
                        <span> Associated Service</span>
                      </Typography>
                    </Box>
                  </Box>
                  <Box className="reqCheckBoxMain">
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={associatedServiceValue.insuracnce}
                            onChange={handleChangeAssociatedService}
                            name="insuracnce"
                            color="primary"
                          />
                        }
                        label="Insuracnce"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={associatedServiceValue.certification}
                            onChange={handleChangeAssociatedService}
                            name="certification"
                            color="primary"
                          />
                        }
                        label="Certification"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={associatedServiceValue.inspectionServices}
                            onChange={handleChangeAssociatedService}
                            name="inspectionServices"
                            color="primary"
                          />
                        }
                        label="Inspection Services"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={associatedServiceValue.customClearance}
                            onChange={handleChangeAssociatedService}
                            name="customClearance"
                            color="primary"
                          />
                        }
                        label="Custom Clearance"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              associatedServiceValue.associatedEntryPermits
                            }
                            onChange={handleChangeAssociatedService}
                            name="associatedEntryPermits"
                            color="primary"
                          />
                        }
                        label="Entry Permits"
                      />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
            {/* Required Equipment  */}
            <Grid container spacing={1}>
              <Grid item xs={12} lg={12} md={12}>
                <Box className="">
                  <Box>
                    <Box className={classes.title}>
                      <Typography
                        variant="h6"
                        className={classes.requestQuoteTitle}
                      >
                        <span className="ServiceIcon">
                          <AllInclusiveIcon />
                        </span>
                        <span> Required Equipment</span>
                      </Typography>
                    </Box>
                  </Box>
                  <Box className="reqCheckBoxMain">
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={requiredEquipmentValue.liftgate}
                            onChange={handleChangeRequiredEquipment}
                            name="liftgate"
                            color="primary"
                          />
                        }
                        label="Liftgate"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={requiredEquipmentValue.palletJack}
                            onChange={handleChangeRequiredEquipment}
                            name="palletJack"
                            color="primary"
                          />
                        }
                        label="PalletJack"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={requiredEquipmentValue.loadStraps}
                            onChange={handleChangeRequiredEquipment}
                            name="loadStraps"
                            color="primary"
                          />
                        }
                        label="Load Straps"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={requiredEquipmentValue.loadBars}
                            onChange={handleChangeRequiredEquipment}
                            name="loadBars"
                            color="primary"
                          />
                        }
                        label="Load bars"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={requiredEquipmentValue.TIRCable}
                            onChange={handleChangeRequiredEquipment}
                            name="TIRCable"
                            color="primary"
                          />
                        }
                        label="TIR Cable"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={requiredEquipmentValue.sideLoading}
                            onChange={handleChangeRequiredEquipment}
                            name="sideLoading"
                            color="primary"
                          />
                        }
                        label="Side Loading"
                      />
                    </Box>
                  </Box>
                  <Box className="reqCheckBoxMain">
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={requiredEquipmentValue.pump}
                            onChange={handleChangeRequiredEquipment}
                            name="pump"
                            color="primary"
                          />
                        }
                        label="Pump"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={requiredEquipmentValue.flowMeter}
                            onChange={handleChangeRequiredEquipment}
                            name="flowMeter"
                            color="primary"
                          />
                        }
                        label="Flow Meter"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={requiredEquipmentValue.scullySystem}
                            onChange={handleChangeRequiredEquipment}
                            name="scullySystem"
                            color="primary"
                          />
                        }
                        label="Scully System"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={requiredEquipmentValue.lashBelt}
                            onChange={handleChangeRequiredEquipment}
                            name="lashBelt"
                            color="primary"
                          />
                        }
                        label="Lash Belt"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={requiredEquipmentValue.tarpaulin}
                            onChange={handleChangeRequiredEquipment}
                            name="tarpaulin"
                            color="primary"
                          />
                        }
                        label="Tarpaulin"
                      />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
            {/* Remarks */}
            <Grid container spacing={1}>
              <Grid item xs={12} lg={8} md={12}>
                <Box className="">
                  <Box>
                    <Box className={classes.title}>
                      <Typography
                        variant="h6"
                        className={classes.requestQuoteTitle}
                      >
                        <span className="ServiceIcon">
                          <AllInclusiveIcon />
                        </span>
                        <span> Remarks</span>
                      </Typography>
                    </Box>
                    <Box className="request1Input">
                      {" "}
                      <TextField
                        id="outlined-basic"
                        label=""
                        variant="outlined"
                        className="request1Input"
                        name="remarks"
                        onChange={handleChangeRemarks}
                      />
                    </Box>
                    <Box className="quoteContentBtn">
                      <button
                        className="common-btn common-btn1"
                        onClick={handleSaveDrfat}
                      >
                        Save as Draft
                      </button>

                      <button className="common-btn common-btn2" type="submit">
                        Submit
                      </button>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </form>
      </Container>
      <ToastContainer />
      <Footer />
    </div>
  );
};

export default RequestQuote;
